// @material-ui/core
import { Grid, Typography } from "@material-ui/core";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import Card from "../library/card/DashboardCard";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apps: 0,
      licenses: 0,
      items: [
        {
          title: "Customers",
          slug: "customers"
        },
        {
          title: "Apps",
          slug: "apps"
        },
        {
          title: "Licenses",
          slug: "licenses"
        }
      ]
    };
  }

  render() {
    return (
      <Grid container spacing={8}>
        <Grid item xs={12}>
          <Typography variant="title">{"Dashboard"}</Typography>
        </Grid>

        {this.state.items.map((item, index) => {
          return (
            <Grid item xs={12} md={6} key={index}>
              <Link to={item.slug}>
                <Card
                  title={item.title}
                  subtitle={item.subtitle}
                  slug={item.slug}
                  toggleLoading={this.props.toggleLoading}
                />
              </Link>
            </Grid>
          );
        })}
      </Grid>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/Dashboard.js